import React from 'react';
import './PdfPage.css';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { getAppEnv } from '../../../config/env';
import { EnvironmentVariables } from '../../types';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw as EnvironmentVariables;
const pdfjsVersion = '2.7.570';

export const PdfPage = ({ data }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <Worker
        workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}
      >
        <Viewer
          fileUrl={`${PUBLIC_URL}/static/public/${data.pdfSource}`}
          plugins={[defaultLayoutPluginInstance]}
        />
      </Worker>
    </div>
  );
};

PdfPage.fetchData = async (_, match, urlObj) => {
  const {
    params: { page }
  } = match;
  console.log('page', page);
  if (new Set(['cabs_intl_AT_policies.html']).has(page)) {
    const pathArray = urlObj.path.split('/');
    const cacheKey =
      'HTML_STATIC_DOC_' + pathArray[pathArray.length - 1].toUpperCase();
    return {
      pushToCache: true, // if this is set then after ssr it will be stored in cache
      cacheKey,
      ...{
        title: 'International Policy',
        pdfSource: `cabs_intl_AT_policiesV2.pdf`
      },
      templateData: { templateName: 'DOC' }
    };
  } else {
    throw new Error('Invalid DOC file requested ');
  }
};

export default PdfPage;
